import React from 'react'
//import {Router, Route, Redirect, hashHistory } from 'react-router'
import {
    BrowserRouter as Router,
    Route
  } from "react-router-dom";

import App from './app'

export default props => (
    <Router>
        <Route path='/' component={App}/>
    </Router>
)


// WEBPACK FOOTER //
// ./src/main/routes.jsx